<template>
  <div></div>
</template>

<script>
export default {
  name: "Cordova",
  mounted() {
    document.addEventListener('deviceready', this.cordova, false);
    document.addEventListener('newNotification', this.newNotification, false);
  },
  methods: {
    async cordova() {
      console.log('init cordova 2')
      if(StatusBar) {
        StatusBar.backgroundColorByName("white");
        StatusBar.styleDefault();
      }
      let isNotificationGranted = await new Promise(
        function(resolve, reject) {
          cordova.plugins.notification.local.hasPermission(granted => {
            resolve(granted)
          });
        }
      )
      if(!isNotificationGranted) {
        isNotificationGranted = await new Promise(
          function(resolve, reject) {
            cordova.plugins.notification.local.requestPermission(granted => {
              resolve(granted)
            });
          }
        )
      }
      
      if(!isNotificationGranted) return
      
    },
    async newNotification({detail: notifications}) {
      if(!window.cordova) return
      notifications.forEach(notification => {
        cordova.plugins.notification.local.schedule({
          title: this.$gettext('You have new notification !!!'),
          text: this.formatText(notification),
          icon: this.avatarUrl(notification.notifiers[0].picture),
          vibrate: true,
          priority: 1,
          lockscreen: true,
          sound: true,
          foreground: true,
        });
      })
      
    },
    formatText(notification) {
      let text = notification.notifiers[0].name;
      text += ' ' + this.formatAction(notification);
      if(notification.entityName == 'course') {
        text += ' @' + notification.entityDetail.name 
      } else if(
        notification.entityName !== 'post' 
        && notification.type !== NOTIFY_GOLF_REQUEST 
        && notification.type !== NOTIFIER_FRIEND_REQUEST 
        && notification.type !== NOTIFY_COMMENT 
        && notification.type !== NOTIFY_REPLY_COMMENT 
        && notification.type !== NOTIFY_NEW_MESSAGE 
        && notification.entityDetail
        && notification.entityDetail.name
      ) {
        text += ' ' + notification.entityDetail.name 
      }
      return text;
    },
    formatAction(item) {
      let text = ''
      switch (item.type) {
        case NOTIFY_NEW_POST:
          text = this.$gettext('creates new post')
          break;
        case NOTIFY_GOLF_REQUEST:
          text = this.$gettext('sent you a goft request')
          break;
        case NOTIFIER_REPLY:
          text = this.$gettext('mentioned you in a discussion')
          break;
        case NOTIFIER_FOLLOW:
          if(item.entityName == 'course') {
            if(item.notifiers.length > 2) {
              text = this.$gettextInterpolate(this.$gettext('and %{number} others follow'), {number: item.notifiers.length - 2})
            } else {
              text = this.$gettext('started following')
            }
          } else {
            if(item.notifiers.length > 2) {
              text = this.$gettextInterpolate(this.$gettext('and %{number} others follow you'), {number: item.notifiers.length - 2})
            } else {
              text = this.$gettext('started following you')
            }
          }
          break;
        case NOTIFIER_FRIEND_REQUEST:
          text = this.$gettext('send you a request')
          break;
        case NOTIFY_NEW_MESSAGE:
          text = this.$gettext('sent you a new message')
          break;
        case NOTIFY_COMMENT:
          text = this.$gettext('comments on your post')
          break;
        case NOTIFY_REPLY_COMMENT:
          text = this.$gettext('replies your comment')
          break;
      }
      return text
    }
  }
};
</script>